"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var productSetting = _interopRequireWildcard(require("@/api/productSetting.js"));
var _validate = require("@/utils/validate");
var _store = require("@/api/store");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {},
  props: {
    fromType: {
      // 来源 0-供应商 1-只需要拿商品ID 6-标签得
      type: [Number, String],
      default: 0
    },
    showBtn: {
      // 是否展示弹窗按钮
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    baseParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    selectType: [Number, String],
    // 查询类型 1-查询spu 2-查询sku
    closeBeforeEmit: {
      // fromType 1/6 时，是否在回调前先关闭弹窗
      type: Boolean,
      default: true
    },
    // 商品名称标签等场景：仅按 skuId 搜索/展示，隐藏 spuId
    skuOnly: {
      type: Boolean,
      default: false
    },
    // 自定义标签选品列表接口（如商品名称标签）
    bindSelectApi: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      details: {},
      // 预留一份数据
      supplierId: '',
      listPram: {
        skuCode: null,
        // SKU编码搜索字段
        skuName: null,
        // SKU名称搜索字段
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      constants: this.$constants,
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      selectedIds: [],
      // 当前页选中的ID数组
      allSelectedItems: [],
      // 存储所有已选商品的完整信息
      merCateList: [],
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      }
    };
  },
  watch: {
    value: {
      handler: function handler(value) {
        this.allSelectedItems = value || [];
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.getCategorySelect();
  },
  methods: {
    getDefaultListPram: function getDefaultListPram() {
      if (this.fromType == 6) {
        if (this.skuOnly) {
          return {
            skuId: '',
            productName: '',
            page: 1,
            limit: this.$constants.page.limit[0]
          };
        }
        return {
          spuId: '',
          skuId: '',
          productName: '',
          page: 1,
          limit: this.$constants.page.limit[0]
        };
      }
      return {
        skuCode: null,
        skuName: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      };
    },
    handleNumberSearchInput: function handleNumberSearchInput(field) {
      var value = String(this.listPram[field] || '').replace(/\D/g, '').slice(0, 50);
      this.listPram[field] = value;
    },
    handleResetSearch: function handleResetSearch() {
      this.listPram = this.getDefaultListPram();
      this.handlerGetListData(this.listPram);
    },
    getSearchParams: function getSearchParams() {
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = _objectSpread({}, pram);
      if (this.fromType == 6) {
        var keys = this.skuOnly ? ['skuId', 'productName'] : ['spuId', 'skuId', 'productName'];
        keys.forEach(function (key) {
          if (params[key] != null) {
            params[key] = String(params[key]).trim();
          }
          if (!params[key]) {
            delete params[key];
          }
        });
        if (this.skuOnly) delete params.spuId;
      }
      return params;
    },
    openInit: function openInit(supplierId) {
      this.supplierId = supplierId;
      this.listPram = this.getDefaultListPram();
      this.details = {};
      this.pram = {};
      this.visible = true;

      // 确保allSelectedItems已经正确初始化
      if (this.value && this.value.length > 0) {
        // 如果有传入的value，确保allSelectedItems与value保持同步
        this.allSelectedItems = _toConsumableArray(this.value);
      } else {
        this.allSelectedItems = [];
        this.selectedIds = [];
      }

      // 加载数据并在加载完成后设置选中状态
      this.handlerGetListData(this.listPram);
    },
    handerSubmit: (0, _validate.Debounce)(function () {
      var _this = this;
      if ([1, 6].includes(this.fromType)) {
        // 套餐组合商品选择
        if (this.closeBeforeEmit) {
          this.visible = false;
        }
        // 确保返回完整的商品信息（不只是ID）
        this.$emit('getSelectProduct', this.allSelectedItems);
        this.$emit('input', this.allSelectedItems);
        return;
      }
      ;
      this.loading = true;
      productSetting.selectProducts({
        productIds: this.allSelectedItems.map(function (item) {
          return item.id;
        }),
        supplierId: this.supplierId
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
      this.selectedIds = [];
      this.allSelectedItems = [];
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      var methodName = this.selectType == 2 ? 'skuListArticle' : 'ListArticle';
      if (this.fromType == 6) {
        methodName = 'bindTagSelect';
      }
      ;
      var queryParams = this.getSearchParams(_objectSpread(_objectSpread(_objectSpread({}, pram), this.baseParams), {}, {
        supplierId: this.supplierId
      }));
      var listRequest = this.fromType == 6 && typeof this.bindSelectApi === 'function' ? this.bindSelectApi(queryParams) : productSetting[methodName](queryParams);
      listRequest.then(function (data) {
        _this2.listData = data;
        _this2.listLoading = false;

        // 在数据加载后，设置选中状态
        _this2.$nextTick(function () {
          _this2.setTableSelection();
        });
      }).catch(function (err) {
        _this2.listLoading = false;
      });
    },
    // 设置表格选中状态
    setTableSelection: function setTableSelection() {
      var _this3 = this;
      if (this.$refs.multipleTable) {
        // 清空当前页的选择
        this.$refs.multipleTable.clearSelection();

        // 仅 goodsNameTag(skuOnly) 按 skuId；其他页面保持原 id 逻辑
        if (this.skuOnly) {
          var selectedSkuIdsSet = new Set(this.allSelectedItems.map(function (item) {
            return item.skuId;
          }));
          this.listData.list.forEach(function (row) {
            if (selectedSkuIdsSet.has(row.skuId)) {
              _this3.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
          return;
        }

        // 获取当前页中应该选中的行
        var selectedIdsSet = new Set(this.allSelectedItems.map(function (item) {
          return item.id;
        }));
        this.listData.list.forEach(function (row) {
          if (selectedIdsSet.has(row.id)) {
            _this3.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      }
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 多选框选中数据
    handleSelectionChange: function handleSelectionChange(selection) {
      var _this4 = this;
      // 仅 goodsNameTag(skuOnly) 按 skuId 去重；其他页面仍按 id
      if (this.skuOnly) {
        this.selectedIds = selection.map(function (item) {
          return item.skuId;
        });
        var _selectedItemsMap = {};
        this.allSelectedItems.forEach(function (item) {
          _selectedItemsMap[item.skuId] = item;
        });
        var currentPageSkuIdsSet = new Set(this.listData.list.map(function (item) {
          return item.skuId;
        }));
        this.allSelectedItems = this.allSelectedItems.filter(function (item) {
          return !currentPageSkuIdsSet.has(item.skuId) || _this4.selectedIds.includes(item.skuId);
        });
        selection.forEach(function (item) {
          if (!_selectedItemsMap[item.skuId]) {
            _this4.allSelectedItems.push(item);
          }
        });
        return;
      }

      // 获取当前页选中的行ID
      this.selectedIds = selection.map(function (item) {
        return item.id;
      });

      // 创建一个ID到商品的映射，保留原有已选商品
      var selectedItemsMap = {};
      this.allSelectedItems.forEach(function (item) {
        selectedItemsMap[item.id] = item;
      });

      // 更新当前页选中商品的状态
      var currentPageIdsSet = new Set(this.listData.list.map(function (item) {
        return item.id;
      }));

      // 移除当前页已取消选择的商品
      this.allSelectedItems = this.allSelectedItems.filter(function (item) {
        return !currentPageIdsSet.has(item.id) || _this4.selectedIds.includes(item.id);
      });

      // 添加当前页新选择的商品
      selection.forEach(function (item) {
        if (!selectedItemsMap[item.id]) {
          _this4.allSelectedItems.push(item);
        }
      });
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this5 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this5.merCateList = res;
      }).catch(function (res) {
        _this5.$message.error(res.message);
      });
    }
  }
};